const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/admin/audience/$sqid/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/admin/audience/$sqid/")({
  beforeLoad: ({
    location,
    params
  }) => {
    redirect({
      to: "/settings/admin/audience/$sqid/info",
      params: {
        sqid: params.sqid
      },
      replace: true,
      search: true,
      hash: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});